var map = {
	"./Abraço na alma.jpg": 138,
	"./Dia das crianças.jpg": 139,
	"./Resurreição sobre rodas.jpg": 140,
	"./acessibility.svg": 141,
	"./atuação permanente beira rio.jpeg": 142,
	"./breakfast.svg": 143,
	"./café coletivo.jpg": 144,
	"./carnaval das antigas.JPG": 145,
	"./charity.svg": 146,
	"./comunity.svg": 147,
	"./curso de voluntário.jpeg": 148,
	"./dog.svg": 149,
	"./drop.svg": 150,
	"./hug.svg": 151,
	"./mask.svg": 152,
	"./mind.svg": 153,
	"./mother.svg": 154,
	"./natal de bem.jpeg": 155,
	"./natal.svg": 156,
	"./rocking-horse.svg": 157,
	"./sangue do meu sangue.JPG": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;